<template>
  <div class="footer" style="margin-top: 46px; width: 100%; text-align: center">
    <span
      style="
        display: block;
        font-size: 12px;
        margin-top: 0.8rem;
        color: #7d90b2;
        letter-spacing: 0;
        text-align: center;
        line-height: 12px;
      "
      >{{ $t("login.copyright") }}</span
    >
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
};
</script>
